// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2yeaM","inner":"Footer_inner__2RwAO","nextIcon":"Footer_nextIcon__3QBRL","innerLeft":"Footer_innerLeft__uUuDk"};